import { render } from "./Map.component.vue?vue&type=template&id=2ffd0722"
import script from "./Map.component.vue?vue&type=script&lang=js"
export * from "./Map.component.vue?vue&type=script&lang=js"

import "./Map.component.vue?vue&type=style&index=0&id=2ffd0722&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__